import React, { useState, useEffect } from "react";
import API from "../../Pages/Service/Baseservice";
import OldDayView from "../../Pages/OldConsultation/OldDayView";
import OldWeekView from "../../Pages/OldConsultation/OldWeekView";
import OldMonthView from "../../Pages/OldConsultation/OldMonthView";
import YearView from "../../Pages/Consultation/YearView";
import "./Oldcalender.css";
import { Navigate, useNavigate } from "react-router-dom";

const OldCalendar = () => {
  const [view, setView] = useState("month");
  const [currentDate, setCurrentDate] = useState(new Date());
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    consultationCustomerDates();
  }, [currentDate, view]);

  const consultationCustomerDates = () => {

    setLoading(true);
    const selectedDate = `${currentDate.getFullYear()}-${String(
      currentDate.getMonth() + 1
    ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(2, "0")}`;

    const req = {
      filter: view,
      selected_date: selectedDate,
    };

    API.post("consultationCustomerDates/condition", req).then((res) => {
      if (res.data.success === true) {
        setBookings(res.data.data);
        setLoading(false);
      } else {
        setBookings([]);
      }
    });
  };


  const prev = () => {
    const d = new Date(currentDate);
    if (view === "month") d.setMonth(d.getMonth() - 1);
    if (view === "week") d.setDate(d.getDate() - 7);
    if (view === "day") d.setDate(d.getDate() - 1);
    if (view === "year") d.setFullYear(d.getFullYear() - 1);
    setCurrentDate(d);
  };


  const next = () => {
    const d = new Date(currentDate);
    if (view === "month") d.setMonth(d.getMonth() + 1);
    if (view === "week") d.setDate(d.getDate() + 7);
    if (view === "day") d.setDate(d.getDate() + 1);
    if (view === "year") d.setFullYear(d.getFullYear() + 1);
    setCurrentDate(d);
  };


  const goToday = () => {
    setCurrentDate(new Date());
  };


  const backBtn = () => {
    navigate("/ConsultationFromList")
  }

  return (
    <div className="admin-container">

      <h2 className="services-title1"> Old Calendar</h2>

      <div className="gc-container">


        <div className="gc-header">


          <div className="gc-left">

            <button onClick={goToday}>Today</button>
            <button onClick={prev} className="nav-btn">&#8592;</button>
            <button onClick={next} className="nav-btn">&#8594;</button>
            <h2>
              {currentDate.toLocaleString("default", {
                month: "long",
                year: "numeric",
              })}
            </h2>
          </div>

          <select
            className="gc-view-select"
            value={view}
            onChange={(e) => setView(e.target.value)}
          >
            <option value="day">Day</option>
            <option value="week">Week</option>
            <option value="month">Month</option>
            <option value="year">Year</option>
          </select>
        </div>

        <div className="gc-body">
          {view === "day" && <OldDayView currentDate={currentDate} bookings={bookings} />}
          {view === "week" && <OldWeekView currentDate={currentDate} bookings={bookings} />}
          {view === "month" && <OldMonthView currentDate={currentDate} bookings={bookings} loading={loading} onDateClick={(date) => { setCurrentDate(date); setView("day"); }} />}
          {view === "year" && <YearView currentDate={currentDate} bookings={bookings} onDateClick={(date) => { setCurrentDate(date); setView("day"); }} />}
        </div>
      </div>
    </div>
  );
};

export default OldCalendar;

